import React from 'react'
import Kenny from '../images/Kenny.png'
import Azka from '../images/Azka.jpeg'
import Eirene from '../images/Eirene.jpg'
import Komang from '../images/Komang.jpg'
import Jessica from '../images/Jessica.png'
import Vanda from '../images/Vanda.jpg'
import Rofan from '../images/Rofan.jpeg'
import Aubert from '../images/Aubert.jpg'
import Bramandika from '../images/Bramandika.jpeg'
import Maura from '../images/Maura.jpeg'

import {ContactContainer, ContactWrapper, ContactH1, ContactP, ContactCard, ContactIcon, ContactH2, ContactH3} from './ContactElements'

const Contact = () => {

  
  return (
    <>
    <ContactContainer id="contact">
        <ContactH1>Contact us if you have any questions😊</ContactH1>
        <ContactH3>Asisten Dosen Kelas A</ContactH3>
        <ContactWrapper>
            <ContactCard onClick={() => window.open( 'https://wa.me/628988655908')}>
                <ContactIcon src={Kenny}/>
                    <ContactH2>Kenny</ContactH2>
                    <ContactP>Aku gatau mau ngomong apa, jadi ini webdevnya yg nulis hehe</ContactP>
            </ContactCard>
            <ContactCard onClick={() => window.open( 'https://wa.me/6287788238245')}>
                <ContactIcon src={Azka}/>
                    <ContactH2>Azka</ContactH2>
                    <ContactP>Aku gatau mau ngomong apa, jadi ini webdevnya yg nulis hehe</ContactP>
            </ContactCard>
        </ContactWrapper>
        <ContactH3>Asisten Dosen Kelas B</ContactH3>
        <ContactWrapper>
            <ContactCard onClick={() => window.open( 'https://wa.me/6285817271262')}>
                <ContactIcon src={Eirene}/>
                    <ContactH2>Eirene</ContactH2>
                    <ContactP>Aku gatau mau ngomong apa, jadi ini webdevnya yg nulis hehe</ContactP>
            </ContactCard>
            <ContactCard onClick={() => window.open( 'https://wa.me/6281936811819')}>
                <ContactIcon src={Komang}/>
                    <ContactH2>Komang</ContactH2>
                    <ContactP>Cowo paling ganteng se-stat 19</ContactP>
            </ContactCard>
        </ContactWrapper>
        <ContactH3>Asisten Dosen Kelas C</ContactH3>
        <ContactWrapper>
            <ContactCard onClick={() => window.open( 'https://wa.me/62895339233988')}>
                <ContactIcon src={Jessica}/>
                    <ContactH2>Jessica</ContactH2>
                    <ContactP>Aku gatau mau ngomong apa, jadi ini webdevnya yg nulis hehe</ContactP>
            </ContactCard>
            <ContactCard onClick={() => window.open( 'https://wa.me/6282234755001')}>
                <ContactIcon src={Vanda}/>
                    <ContactH2>Vanda</ContactH2>
                    <ContactP>Aku gatau mau ngomong apa, jadi ini webdevnya yg nulis hehe</ContactP>
            </ContactCard>
        </ContactWrapper>
        <ContactH3>Asisten Dosen Kelas D</ContactH3>
        <ContactWrapper>
            <ContactCard onClick={() => window.open( 'https://wa.me/6281295969168')}>
                <ContactIcon src={Rofan}/>
                    <ContactH2>Rofan</ContactH2>
                    <ContactP>Kalo ngechat gausa formal-formal plis🙏</ContactP>
            </ContactCard>
            <ContactCard onClick={() => window.open( 'https://wa.me/6281331913541')}>
                <ContactIcon src={Aubert}/>
                    <ContactH2>Aubert</ContactH2>
                    <ContactP>Bingung</ContactP>
            </ContactCard>
        </ContactWrapper>
        <ContactH3>Asisten Dosen Kelas IUP</ContactH3>
        <ContactWrapper>
            <ContactCard onClick={() => window.open( 'https://wa.me/6285155157035')}>
                <ContactIcon src={Bramandika}/>
                    <ContactH2>Bramandika</ContactH2>
                    <ContactP>Follow igku @bramrumapea</ContactP>
            </ContactCard>
            <ContactCard onClick={() => window.open( 'https://wa.me/62811112703')}>
                <ContactIcon src={Maura}/>
                    <ContactH2>Maura</ContactH2>
                    <ContactP>Aku gatau mau ngomong apa, jadi ini webdevnya yg nulis hehe</ContactP>
            </ContactCard>
        </ContactWrapper>
    </ContactContainer>
    </>
  )
}

export default Contact